/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

const EMP_LIST_URL = `${API_BASE_URL}/api/employees`;

export default function EmployeeList() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading]     = useState(false);
  const [search, setSearch]       = useState("");
  const [editId, setEditId]       = useState(null);
  const [editData, setEditData]   = useState({});

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const res = await axios.get(EMP_LIST_URL);
      setEmployees(res.data?.data || res.data || []);
    } catch (e) {
      console.error("Failed to load employees", e);
    }
    setLoading(false);
  };

  useEffect(() => { fetchEmployees(); }, []);

  const handleDelete = async (name) => {
    if (!window.confirm(`Delete employee "${name}"?`)) return;
    try {
      await axios.delete(`${EMP_LIST_URL}/${encodeURIComponent(name)}`);
      fetchEmployees();
    } catch (e) { alert("Delete failed"); }
  };

  const handleEdit = (emp) => {
    setEditId(emp._id || emp.name);
    setEditData({ ...emp });
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${EMP_LIST_URL}/${encodeURIComponent(editData.name)}`, editData);
      setEditId(null);
      fetchEmployees();
    } catch (e) { alert("Update failed"); }
  };

  const downloadCSV = () => {
    const header = "Name,Password,Role\n";
    const rows = filtered.map(e => `${e.name},${e.password || ""},${e.role || ""}`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "employees.csv";
    a.click();
  };

  const filtered = employees.filter(e =>
    (e.name || "").toLowerCase().includes(search.toLowerCase())
  );

  const S = {
    container: { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    toolbar:   { display: "flex", gap: 10, alignItems: "center", padding: "14px 16px", flexWrap: "wrap" },
    input:     { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    btnYellow: { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:  { background: "#000", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    table:     { width: "100%", borderCollapse: "collapse" },
    th:        { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:        { border: "1px solid #000", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Employee List</h2>

      <div style={S.toolbar}>
        <input
          style={S.input}
          placeholder="Search by name..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <button style={S.btnYellow} onClick={downloadCSV}>⬇ Download CSV</button>
        <span style={{ marginLeft: "auto", fontSize: 13, color: "#555" }}>
          {filtered.length} employee{filtered.length !== 1 ? "s" : ""}
        </span>
      </div>

      {loading ? (
        <p style={{ padding: 20 }}>Loading employees...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>#</th>
                <th style={S.th}>Name</th>
                <th style={S.th}>Password</th>
                <th style={S.th}>Role</th>
                <th style={S.th}>Status</th>
                <th style={S.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={6} style={{ ...S.td, color: "#888" }}>No employees found</td></tr>
              ) : filtered.map((emp, i) => (
                <tr key={emp._id || emp.name} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                  <td style={S.td}>{i + 1}</td>
                  <td style={S.td}>
                    {editId === (emp._id || emp.name) ? (
                      <input style={S.input} value={editData.name} onChange={e => setEditData({ ...editData, name: e.target.value })} />
                    ) : (
                      <strong>{emp.name}</strong>
                    )}
                  </td>
                  <td style={S.td}>
                    {editId === (emp._id || emp.name) ? (
                      <input style={S.input} value={editData.password || ""} onChange={e => setEditData({ ...editData, password: e.target.value })} />
                    ) : (
                      emp.password ? <span style={{ color: "#27ae60", fontWeight: "bold" }}>🔒 Set</span> : <span style={{ color: "#c0392b" }}>⚠ None</span>
                    )}
                  </td>
                  <td style={S.td}>
                    {editId === (emp._id || emp.name) ? (
                      <input style={S.input} value={editData.role || ""} onChange={e => setEditData({ ...editData, role: e.target.value })} />
                    ) : (emp.role || "—")}
                  </td>
                  <td style={S.td}>
                    <span style={{
                      background: emp.password ? "#e6f9ee" : "#fff8e1",
                      color: emp.password ? "#27ae60" : "#d68910",
                      padding: "3px 10px", borderRadius: 10, fontSize: 12, fontWeight: "bold"
                    }}>
                      {emp.password ? "Active" : "No Password"}
                    </span>
                  </td>
                  <td style={S.td}>
                    {editId === (emp._id || emp.name) ? (
                      <>
                        <button style={{ ...S.btnYellow, marginRight: 6 }} onClick={handleUpdate}>✅ Save</button>
                        <button style={S.btnBlack} onClick={() => setEditId(null)}>✕ Cancel</button>
                      </>
                    ) : (
                      <>
                        <button style={{ ...S.btnYellow, marginRight: 6 }} onClick={() => handleEdit(emp)}>✏ Edit</button>
                        <button style={S.btnBlack} onClick={() => handleDelete(emp.name)}>🗑 Delete</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
